import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { isPageSeoEnabled } from '../config/siteConfig'
import './Legal.css'

const Privacy = () => {
  const seoEnabled = isPageSeoEnabled('privacy')
  
  return (
    <div className="legal-page">
      <SeoHead
        title="Privacy Policy | SIBR Lifescience"
        description="SIBR Lifescience privacy policy. Learn how we collect, use, and protect your personal information."
        canonical="/privacy"
        seoEnabled={seoEnabled}
      />
      
      <section className="legal-hero">
        <div className="container">
          <h1>Privacy Policy</h1>
          <p>How we collect, use, and protect your information.</p>
        </div>
      </section>

      <section className="legal-content section">
        <div className="container">
          <div className="legal-wrapper">
            <article className="legal-article">
              <h2>Introduction</h2>
              <p>
                SIBR Life Sciences Private Limited ("SIBR Lifescience," "we," "us," or "our") is 
                committed to protecting your privacy. This Privacy Policy explains how we collect, 
                use, disclose, and safeguard your information when you visit our website.
              </p>
              <p>
                Please read this Privacy Policy carefully. By using our website, you consent to 
                the practices described in this policy.
              </p>

              <h2>Information We Collect</h2>
              <h3>Information You Provide</h3>
              <p>We may collect information that you voluntarily provide when you:</p>
              <ul>
                <li>Fill out our contact form</li>
                <li>Subscribe to our newsletter</li>
                <li>Submit business inquiries</li>
                <li>Communicate with us via email or phone</li>
              </ul>
              <p>This information may include:</p>
              <ul>
                <li>Name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Company name</li>
                <li>Message content</li>
              </ul>

              <h3>Automatically Collected Information</h3>
              <p>
                When you visit our website, we may automatically collect certain information 
                about your device and browsing activity, including:
              </p>
              <ul>
                <li>IP address</li>
                <li>Browser type and version</li>
                <li>Operating system</li>
                <li>Referring website</li>
                <li>Pages visited and time spent</li>
                <li>Date and time of visit</li>
              </ul>

              <h2>How We Use Your Information</h2>
              <p>We may use the information we collect to:</p>
              <ul>
                <li>Respond to your inquiries and provide customer support</li>
                <li>Process business partnership requests</li>
                <li>Send administrative information and updates</li>
                <li>Analyze website usage to improve our services</li>
                <li>Comply with legal obligations</li>
                <li>Protect against fraudulent or illegal activity</li>
              </ul>

              <h2>Information Sharing</h2>
              <p>
                We do not sell, trade, or otherwise transfer your personal information to 
                third parties except in the following circumstances:
              </p>
              <ul>
                <li><strong>Service Providers:</strong> We may share information with trusted 
                    third-party service providers who assist us in operating our website.</li>
                <li><strong>Legal Requirements:</strong> We may disclose information when required 
                    by law or to protect our rights and safety.</li>
                <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or 
                    sale of assets, your information may be transferred.</li>
              </ul>

              <h2>Data Security</h2>
              <p>
                We implement appropriate technical and organizational security measures to protect 
                your personal information against unauthorized access, alteration, disclosure, or 
                destruction. However, no method of transmission over the Internet is 100% secure, 
                and we cannot guarantee absolute security.
              </p>

              <h2>Cookies and Tracking</h2>
              <p>
                Our website may use cookies and similar tracking technologies to enhance your 
                browsing experience. Cookies are small files stored on your device that help us 
                understand how you use our website. You can control cookie preferences through 
                your browser settings.
              </p>

              <h2>Third-Party Links</h2>
              <p>
                Our website may contain links to third-party websites, including healthcare 
                platforms. We are not responsible for the privacy practices of these external 
                sites. We encourage you to review their privacy policies before providing any 
                personal information.
              </p>

              <h2>Your Rights</h2>
              <p>Subject to applicable law, you may have the right to:</p>
              <ul>
                <li>Access and receive a copy of your personal information</li>
                <li>Request correction of inaccurate information</li>
                <li>Request deletion of your personal information</li>
                <li>Object to or restrict certain processing</li>
                <li>Withdraw consent where processing is based on consent</li>
              </ul>
              <p>
                To exercise these rights, please contact us using the information provided below.
              </p>

              <h2>Children's Privacy</h2>
              <p>
                Our website is not intended for children under 18 years of age. We do not 
                knowingly collect personal information from children. If you believe we have 
                collected information from a child, please contact us immediately.
              </p>

              <h2>Changes to This Policy</h2>
              <p>
                We may update this Privacy Policy from time to time. Changes will be posted on 
                this page with an updated revision date. Your continued use of our website 
                following any changes constitutes your acceptance of the revised policy.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have questions about this Privacy Policy or our data practices, please 
                contact us:
              </p>
              <address>
                <strong>SIBR Life Sciences Private Limited</strong><br />
                Email: <a href="mailto:privacy@sibrlifescience.com">privacy@sibrlifescience.com</a><br />
                <Link to="/contact">Contact Page</Link>
              </address>

              <p className="last-updated">
                <em>Last updated: December 2024</em>
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Privacy

